import { useCallback } from 'react';

import { useAnalyticsUtilities } from '@air/analytics';

import META from '~/hooks/events/useTrackOpenedInAir.meta';

export type TrackOpenedInAirParams = {
  board_id?: string;
  clip_id?: string;
  library_id?: string;
};

export const useTrackOpenedInAir = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenedInAir = useCallback(
    (params: TrackOpenedInAirParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackOpenedInAir };
};
